import { render, staticRenderFns } from "./AdminTicketDetails.vue?vue&type=template&id=7c95d78a&scoped=true"
import script from "./AdminTicketDetails.vue?vue&type=script&lang=js"
export * from "./AdminTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminTicketDetails.vue?vue&type=style&index=0&id=7c95d78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c95d78a",
  null
  
)

export default component.exports